import { loadUserOneOptions } from "../vite/loadConfig";
function isMissingViteConfigError(error) {
  return error instanceof Error && error.message.startsWith("No config config in ") && error.message.endsWith(" Is this the correct directory?");
}
async function loadUserOptions() {
  try {
    return await loadUserOneOptions("build");
  } catch (error) {
    if (isMissingViteConfigError(error)) {
      return void 0;
    }
    throw error;
  }
}
async function run(args) {
  process.env.IS_VXRN_CLI = "true";
  var { patch } = await import("vxrn");
  var options = await loadUserOptions();
  var patches = options === null || options === void 0 ? void 0 : options.oneOptions.patches;
  if (process.env.DEBUG) {
    console.info("User patches:", Object.keys(patches || {}));
  }
  await patch({
    root: process.cwd(),
    deps: patches,
    force: args.force
  });
}
export {
  run
};
//# sourceMappingURL=patch.js.map
